import { createRef, Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import unescapedText from 'I18n/utils/unescapedText';
import { debounce } from 'underscore';
import EditForm from 'ContentComponents/components/cmv2/EditForm';
import FieldInheritanceIcon from 'ContentComponents/components/cmv2/FieldInheritanceIcon';
import { Small } from 'foundations-components/transitional/components/Small';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import NavMarker from 'react-rhumb/NavMarker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Alert } from 'foundations-components/transitional/components/Alert';
import SidebarSection from '../components/sidebar/SidebarSection';
import NavigationBreadcrumb from '../components/themeSettings/NavigationBreadcrumb';
import ThemeSettingsFieldWrapper from '../components/themeSettings/ThemeSettingsFieldWrapper';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import * as ThemeSettingsActions from '../actions/ThemeSettingsActions';
import * as Actions from '../actions/Actions';
import * as PresetActions from '../actions/PresetActions';
import { isEqual } from 'underscore';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { getSettingsFormSpec, getCanRedo, getCanUndo, getThemeBreakpointStyles, getThemeSettingsValues, getThemeInheritanceDataOverrides, getThemeSettingsRequestStatus, getUniversalThemeSettingsRequestStatus, getActiveThemePresetId } from '../selectors/themeSettingsSelectors';
import { getBusinessUnitId, getPreviewIframeLoaded, getSelectedBreakpoint, getIsPresetPanelOpen, getIsPortalsHmrReady } from '../selectors/appSelectors';
import { getPreviewUrl } from '../selectors/previewSelectors';
import { getActiveFieldKey, getThemeSaveSuccessful, getThemeLastSaveWasAutoSave } from '../selectors/themeSettingsMetaSelectors';
import { getThemeMessages, getThemePath, getThemeResponsiveBreakpointsByName } from '../selectors/themeSelectors';
import { getIsUngatedForUniversalThemeEditing, getUserLocale } from '../selectors/authSelectors';
import { getHasThemePresetsAccess, getActiveThemePresetStyles, getPresetsList, getHasLoadedPresets, getSelectedThemePresetId } from '../selectors/presetsSelectors';
import { isFulfilled } from '../utils/requestStatus';
import { isPortalPreviewUrl } from '../utils/urls';
import { getClosestNonEmptyParentKey } from '../utils/themeSettings';
import * as CustomWidgetFieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { getFieldFromKey } from 'ContentComponents/components/cmv2/utils';
import { MOBILE, TABLET } from '../constants/breakpoints';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import * as UsageInteractionTypes from '../constants/usage/InteractionTypes';
import DefaultThemeMofoFields from '../components/ThemeMofoFields';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import ActiveThemePresetCard from '../components/presets/ActiveThemePresetCard';
import PresetListPanel from '../components/presets/PresetListPanel';
import ThemeSettingsHeader from '../components/sidebar/ThemeSettingsHeader';
import ContentRoutes from 'ContentUtils/Routes';
import UniversalThemeHeaderMenu from '../components/themeSettings/UniversalThemeHeaderMenu';
import { EllipsesIcon } from 'foundations-assets/icons/components/EllipsesIcon';
import { RefreshIcon } from 'foundations-assets/icons/components/RefreshIcon';
import * as AppActions from '../actions/AppActions';
import GlobalStylesPluginHeader from '../components/sidebar/GlobalStylesPluginHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themeSettings.${key}`;
const StyleFieldsLabelWrapper = styled.span.withConfig({
  displayName: "ThemeSettingsContainer__StyleFieldsLabelWrapper"
})(["word-break:break-all;"]);
const StyleFieldsResetButtonWrapper = styled.span.withConfig({
  displayName: "ThemeSettingsContainer__StyleFieldsResetButtonWrapper"
})(["display:inline-block;vertical-align:top;"]);
const mapStateToProps = (state, props) => {
  const {
    isUniversalThemeEditing
  } = props;
  return {
    activeThemePresetId: getActiveThemePresetId(state),
    activeThemePresetStyles: getActiveThemePresetStyles(state),
    businessUnitId: getBusinessUnitId(state),
    canRedo: getCanRedo(state),
    canUndo: getCanUndo(state),
    fieldKey: getActiveFieldKey(state),
    formData: getThemeSettingsValues(state),
    formSpec: getSettingsFormSpec(state),
    isPresetPanelOpen: getIsPresetPanelOpen(state),
    hasLoadedThemeSettings: isFulfilled(getThemeSettingsRequestStatus(state)),
    hasLoadedUniversalThemeSettings: isFulfilled(getUniversalThemeSettingsRequestStatus(state)),
    hasLoadedPresets: getHasLoadedPresets(state),
    hasThemePresetsAccess: getHasThemePresetsAccess(state, {
      isUniversalThemeEditing
    }),
    isPortalsHmrReady: getIsPortalsHmrReady(state),
    previewUrl: getPreviewUrl(state),
    previewIframeLoaded: getPreviewIframeLoaded(state),
    selectedBreakpoint: getSelectedBreakpoint(state),
    selectedThemePresetId: getSelectedThemePresetId(state),
    themeBreakpointStyles: getThemeBreakpointStyles(state),
    responsiveBreakpointsByName: getThemeResponsiveBreakpointsByName(state),
    themePath: getThemePath(state),
    themeInheritanceDataOverrides: getThemeInheritanceDataOverrides(state),
    themeMessages: getThemeMessages(state),
    userLocale: getUserLocale(state),
    isUngatedForUniversalThemeEditing: getIsUngatedForUniversalThemeEditing(state),
    presets: getPresetsList(state),
    themeSaveSuccessful: getThemeSaveSuccessful(state),
    lastSaveWasAutoSave: getThemeLastSaveWasAutoSave(state)
  };
};
const mapDispatchToProps = {
  onRedoChange: ThemeSettingsActions.redoChange,
  onUndoChange: ThemeSettingsActions.undoChange,
  onUpdateFieldKey: ThemeSettingsActions.updateSettingsFieldKey,
  onUpdateSettings: ThemeSettingsActions.updateSettings,
  onClearSettings: ThemeSettingsActions.clearThemeSettings,
  onResetField: ThemeSettingsActions.resetFieldSettings,
  reloadIframePreview: Actions.reloadIframePreview,
  onFetchPresets: PresetActions.fetchPresets,
  setIsPresetPanelOpen: AppActions.setIsPresetPanelOpen
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class ThemeSettingsContainer extends Component {
  constructor(_props) {
    super(_props);
    this.handleOpenFullThemeEditor = () => {
      const {
        templatePath,
        themePath
      } = this.props;
      const params = {
        redirectUrl: window.location.pathname,
        fromAppName: 'pageEditor',
        templatePath
      };
      window.location = ContentRoutes.themeEditor(themePath, params);
    };
    this.getThemePathFromUrl = () => {
      const path = window.location.pathname;
      const themePath = path.split('/edit/');
      if (themePath && themePath.length > 1) {
        return decodeURI(themePath[1]);
      }
      return null;
    };
    this.resetScrollPosition = () => {
      const columnNode = this._columnRef.current;
      if (columnNode) {
        columnNode.scrollTop = 0;
      }
    };
    this.readFieldKeyCookie = themePath => {
      const sessionFieldKeyMatch = document.cookie.match(new RegExp(`${themePath}=([^;]+)`, 'i'));
      const sessionFieldKey = sessionFieldKeyMatch && sessionFieldKeyMatch[1];
      return sessionFieldKey ? sessionFieldKey.split(',') : null;
    };
    this.setFieldKeyCookie = fieldKey => {
      // Set cookie to expire in 2 hours
      const date = new Date();
      date.setTime(date.getTime() + 2 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${this.props.themePath}=${fieldKey}; ${expires}; path=/`;
    };
    this.handleClearThemeSettings = () => {
      this.handleInteractionTracking(UsageInteractionTypes.RESET_THEME_SETTINGS_FORM);
      this.props.onClearSettings();
      this.props.onUpdateFieldKey(null);
    };
    this.handleFieldKeyChange = fieldKey => {
      const {
        clearScrollToThemePath,
        scrollToThemeField
      } = this.props;
      if (scrollToThemeField && clearScrollToThemePath) clearScrollToThemePath();
      this.props.onUpdateFieldKey(fieldKey);
      this.setFieldKeyCookie(fieldKey);
    };
    this.getTrackingUpdatedValue = value => {
      switch (typeof value) {
        case 'object':
          return JSON.stringify(value);
        default:
          return value.toString();
      }
    };
    this.handleInteractionTracking = trackingType => {
      const {
        isUniversalThemeEditing,
        trackUpdateThemeSettings,
        trackInteraction
      } = this.props;
      if (isUniversalThemeEditing && trackUpdateThemeSettings) {
        trackUpdateThemeSettings({
          action: trackingType
        });
      } else {
        trackInteraction === null || trackInteraction === void 0 || trackInteraction(trackingType);
      }
    };
    this.handleFormUpdate = (key, value, module) => {
      const {
        onUpdateSettings,
        selectedBreakpoint,
        formSpec = {
          fields: []
        },
        hasThemePresetsAccess,
        trackUpdateThemeSettings
      } = this.props;
      const {
        fields
      } = formSpec;
      const field = getFieldFromKey(fields, key) || {};
      trackUpdateThemeSettings === null || trackUpdateThemeSettings === void 0 || trackUpdateThemeSettings({
        fieldType: field.type,
        fieldPath: key.join('.'),
        value: this.getTrackingUpdatedValue(value),
        themePath: this.getThemePathFromUrl(),
        action: 'update-theme-settings',
        preset: hasThemePresetsAccess
      });
      this.setState({
        showApplyButton: true
      });
      this._debouncedReloadIframe();
      onUpdateSettings({
        breakpoint: selectedBreakpoint,
        key,
        themeSettings: module,
        value
      });
    };
    this.handleFieldReset = key => {
      const {
        onResetField,
        selectedBreakpoint
      } = this.props;
      onResetField(key, selectedBreakpoint);
    };
    this.handleBrowsePresetsClick = () => {
      this.props.setIsPresetPanelOpen(true);
    };
    this.handleClosePresetPanel = () => {
      this.props.setIsPresetPanelOpen(false);
    };
    this.getTranslatedBreakpointLabel = breakpoint => {
      const {
        themeMessages,
        userLocale
      } = this.props;
      const {
        label: breakpointLabel,
        name
      } = breakpoint;
      const messages = themeMessages && themeMessages.userLocale ? themeMessages[userLocale] : {};
      let label = breakpointLabel;
      if (name === TABLET || name === MOBILE) {
        const breakpointLabelKey = `previewResizeControls.devices.${name}`;
        label = unescapedText(breakpointLabelKey);
      } else {
        const labelTranslationKey = `breakpoints.${name}.label`;
        label = messages[labelTranslationKey] ? messages[labelTranslationKey].message : label;
      }
      return label.toLowerCase();
    };
    this.showPresetFetchError = () => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        titleText: unescapedText('theme-previewer.themePresets.fetchError.title'),
        message: unescapedText('theme-previewer.themePresets.fetchError.message')
      });
    };
    this.renderFieldResetButton = labelProps => {
      const {
        formData = {},
        selectedBreakpoint,
        themeBreakpointStyles = {}
      } = this.props;
      const {
        inheritedValue,
        isDefaultValue,
        fieldKey,
        onFieldUnlink,
        scrollToField
      } = labelProps;
      const fieldValue = selectedBreakpoint ? getDeepValue(themeBreakpointStyles, [selectedBreakpoint, 'fieldStyles', ...fieldKey]) : getDeepValue(formData, fieldKey);

      //does not allow reset if in universal theme editor and has no access to theme
      const isResettable = fieldValue !== undefined && this.getCanAccessThemeEdit();
      const isOccurence = fieldKey.some(key => typeof key === 'number');
      const onClickHandler = evt => {
        evt.stopPropagation();
        evt.preventDefault();
        const themeSettings = selectedBreakpoint ? getDeepValue(themeBreakpointStyles, [selectedBreakpoint, 'fieldStyles']) : formData;
        const closestNonEmptyParentFieldKey = getClosestNonEmptyParentKey(fieldKey, themeSettings);
        this.setState({
          showApplyButton: true
        });
        this.handleFieldReset(closestNonEmptyParentFieldKey);
      };
      if (inheritedValue) {
        return /*#__PURE__*/_jsx(FieldInheritanceIcon, {
          inheritedValue: inheritedValue,
          isDefaultValue: isDefaultValue,
          onResetClick: evt => {
            this.handleInteractionTracking(UsageInteractionTypes.RESET_INHERITING_THEME_FIELD);
            onClickHandler(evt);
          },
          onUnlinkClick: onFieldUnlink ? evt => {
            this.handleInteractionTracking(UsageInteractionTypes.UNLINK_INHERITING_THEME_FIELD);
            onFieldUnlink(evt);
          } : undefined,
          scrollToField: scrollToField
        });
      }
      if (!isResettable || isOccurence) return null;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('resetFieldTooltip')
        }),
        children: /*#__PURE__*/_jsx(IconButton, {
          use: "link",
          onClick: evt => {
            this.handleInteractionTracking(UsageInteractionTypes.RESET_THEME_FIELD);
            onClickHandler(evt);
          },
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(RefreshIcon, {
            size: "200",
            color: "icon-interactive-default"
          })
        })
      });
    };
    this.renderFieldLabel = props => {
      const {
        fieldKey,
        fieldType
      } = props;
      const {
        formSpec = {
          fields: []
        }
      } = this.props;
      const {
        fields
      } = formSpec;
      const field = getFieldFromKey(fields, fieldKey) || {};
      return /*#__PURE__*/_jsxs(StyleFieldsLabelWrapper, {
        children: [/*#__PURE__*/_jsx(SanitizedLabel, {
          label: props.label
        }), (fieldType !== CustomWidgetFieldTypes.GROUP || field.occurrence && fieldType === CustomWidgetFieldTypes.GROUP) && /*#__PURE__*/_jsx(StyleFieldsResetButtonWrapper, {
          children: this.renderFieldResetButton(props)
        })]
      });
    };
    this.handleReloadIframePreview = () => {
      const {
        isUniversalThemeEditing,
        isPortalsHmrReady,
        previewUrl,
        reloadScalableEditorIframePreview,
        reloadIframePreview
      } = this.props;
      // Skip full refresh if portals hot reload is available
      if (isPortalsHmrReady && isPortalPreviewUrl(previewUrl)) {
        return;
      }
      if (isUniversalThemeEditing) {
        reloadScalableEditorIframePreview === null || reloadScalableEditorIframePreview === void 0 || reloadScalableEditorIframePreview();
      } else {
        reloadIframePreview();
      }
    };
    this._columnRef = /*#__PURE__*/createRef();
    this.state = {
      showApplyButton: false
    };
    this._debouncedReloadIframe = debounce(this.handleReloadIframePreview, 2000);
  }
  componentDidMount() {
    const {
      hasThemePresetsAccess,
      themePath,
      onFetchPresets
    } = this.props;
    if (hasThemePresetsAccess) {
      onFetchPresets(themePath).catch(this.showPresetFetchError);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      fieldKey,
      hasThemePresetsAccess,
      hasLoadedPresets,
      selectedBreakpoint,
      themePath,
      onFetchPresets
    } = this.props;
    if (themePath !== prevProps.themePath) {
      const sessionFieldKey = this.readFieldKeyCookie(themePath);
      if (sessionFieldKey) {
        this.props.onUpdateFieldKey(sessionFieldKey);
      }
      if (hasThemePresetsAccess && !hasLoadedPresets) {
        onFetchPresets(themePath).catch(this.showPresetFetchError);
      }
    }
    if (!isEqual(fieldKey, prevProps.fieldKey)) {
      this.resetScrollPosition();
    }
    if (prevProps.selectedBreakpoint !== selectedBreakpoint) {
      this.handleFieldKeyChange([]);
    }
  }
  get isPresetPanelOpen() {
    const {
      hasThemePresetsAccess,
      isPresetPanelOpen
    } = this.props;
    return hasThemePresetsAccess && isPresetPanelOpen;
  }
  get showPresets() {
    const {
      fieldKey,
      hasThemePresetsAccess,
      presets
    } = this.props;
    const isRootSettingView = !fieldKey || fieldKey && !fieldKey.length;
    return hasThemePresetsAccess && isRootSettingView && presets.length > 0;
  }
  get hasUserThemeOverrides() {
    const {
      formData
    } = this.props;
    return Boolean(formData && Object.keys(formData).length > 0);
  }
  getCanAccessThemeEdit() {
    const {
      isUniversalThemeEditing,
      hasThemeEditAccess
    } = this.props;
    return Boolean(!isUniversalThemeEditing || hasThemeEditAccess);
  }
  renderBreadcrumbs() {
    const {
      fieldKey,
      formData = {},
      formSpec = {
        fields: []
      }
    } = this.props;
    const {
      fields
    } = formSpec;
    const isRootLevel = !fieldKey || fieldKey && !fieldKey.length;
    return isRootLevel ? null : /*#__PURE__*/_jsx(NavigationBreadcrumb, {
      fieldKey: fieldKey || [],
      fields: fields,
      module: formData,
      onKeyChange: this.handleFieldKeyChange
    });
  }
  renderResetButton() {
    const dropdownButton = /*#__PURE__*/_jsx(Flex, {
      alignSelf: "center",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(EllipsesIcon, {
        size: "600",
        color: "icon-interactive-default"
      })
    });
    return /*#__PURE__*/_jsx(Dropdown, {
      "data-test-id": "reset-to-default-dropdown",
      autoPlacement: "vert",
      buttonUse: "transparent",
      buttonText: dropdownButton,
      buttonStyles: {
        paddingInline: '0',
        paddingBlock: '0'
      },
      caretRenderer: null,
      placement: "bottom left",
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "reset-to-default",
        onClick: this.handleClearThemeSettings,
        use: "link",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('patagoniaResetButton')
        })
      })
    });
  }
  renderBreakpointEditingAlert() {
    const {
      selectedBreakpoint,
      responsiveBreakpointsByName
    } = this.props;
    if (!selectedBreakpoint) return null;
    const breakpoint = responsiveBreakpointsByName[selectedBreakpoint];
    const breakpointLabel = this.getTranslatedBreakpointLabel(breakpoint);
    return /*#__PURE__*/_jsx(Alert, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('breakpointsAlert'),
        options: {
          breakpointLabel
        }
      })
    });
  }
  renderHeaderContent() {
    const {
      toggleDependentsPanel,
      isUniversalThemeEditing: _isUniversalThemeEditing,
      isUngatedForUniversalThemeEditing,
      handleOpenRevisionsModal,
      hasThemePresetsAccess,
      handleClosePatagoniaSidebar,
      isGlobalStylesPlugin,
      fieldKey
    } = this.props;
    const isUniversalThemeEditing = isUngatedForUniversalThemeEditing && handleOpenRevisionsModal && _isUniversalThemeEditing;
    const maybeBreadcrumbs = this.renderBreadcrumbs();
    return isGlobalStylesPlugin ? /*#__PURE__*/_jsx(GlobalStylesPluginHeader, {
      fieldKey: fieldKey,
      breadcrumbs: maybeBreadcrumbs
    }) : /*#__PURE__*/_jsxs("div", {
      children: [!isUniversalThemeEditing && maybeBreadcrumbs, /*#__PURE__*/_jsx(ThemeSettingsHeader, {
        breadcrumbsAreVisible: !!maybeBreadcrumbs,
        breakpointEditingAlert: this.renderBreakpointEditingAlert(),
        canAccessThemeEdit: this.getCanAccessThemeEdit(),
        isUniversalThemeEditing: isUniversalThemeEditing,
        onClose: handleClosePatagoniaSidebar,
        resetButton: isUniversalThemeEditing ? /*#__PURE__*/_jsx(UniversalThemeHeaderMenu, {
          handleOpenRevisionsModal: handleOpenRevisionsModal,
          handleClearThemeSettings: this.handleClearThemeSettings,
          handleOpenFullThemeEditor: this.handleOpenFullThemeEditor,
          canAccessThemeEdit: this.getCanAccessThemeEdit()
        }) : this.renderResetButton(),
        showThemeTile: isUniversalThemeEditing && !hasThemePresetsAccess,
        toggleDependentsPanel: toggleDependentsPanel
      }), isUniversalThemeEditing && maybeBreadcrumbs]
    });
  }
  renderApplyButton() {
    const {
      previewIframeLoaded,
      isUniversalThemeEditing,
      themeSaveSuccessful,
      lastSaveWasAutoSave
    } = this.props;
    const {
      showApplyButton
    } = this.state;
    if (!showApplyButton) return null;

    //theme settings can be saved through theme editor or universal editor
    const showResult = previewIframeLoaded || isUniversalThemeEditing && themeSaveSuccessful;
    const universalThemeLabelCompletedText = lastSaveWasAutoSave ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('universalChangesAutoSaved')
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('universalChangesSaved')
    });
    return /*#__PURE__*/_jsxs(View, {
      paddingInline: "600",
      marginBlockStart: "300",
      marginBlockEnd: "600",
      as: "div",
      children: [/*#__PURE__*/_jsx(LoadingSpinner, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('savingChanges')
        }),
        labelCompletedText: isUniversalThemeEditing ? universalThemeLabelCompletedText : /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('changesSaved')
        }),
        size: "sm",
        showLabel: true,
        showResult: showResult,
        marginInlineStart: "0",
        paddingBlockStart: "500"
      }), !isUniversalThemeEditing && /*#__PURE__*/_jsxs(Small, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('cantSeeUpdates')
        }), /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: this.handleReloadIframePreview,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('clickToRefresh')
          })
        })]
      }), isUniversalThemeEditing && /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('publishUniversalChanges')
        })
      })]
    });
  }
  renderPreset() {
    const {
      activeThemePresetId,
      themePath
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderBlockEndWidth: "100",
      children: /*#__PURE__*/_jsx(SidebarSection, {
        paddingBlockStart: "500",
        children: /*#__PURE__*/_jsx(ActiveThemePresetCard, {
          activeThemePresetId: activeThemePresetId,
          hasUserThemeOverrides: this.hasUserThemeOverrides,
          onBrowsePresetsClick: this.handleBrowsePresetsClick,
          themePath: themePath
        })
      })
    });
  }
  renderPresetListPanel() {
    const {
      activeThemePresetId,
      isUniversalThemeEditing,
      presets,
      selectedThemePresetId,
      themePath
    } = this.props;
    return /*#__PURE__*/_jsx(PresetListPanel, {
      activeThemePresetId: activeThemePresetId,
      hasUserThemeOverrides: this.hasUserThemeOverrides,
      isUniversalThemeEditing: isUniversalThemeEditing,
      onClose: this.handleClosePresetPanel,
      presets: presets,
      reloadIframePreview: this.handleReloadIframePreview,
      selectedThemePresetId: selectedThemePresetId,
      themePath: themePath
    });
  }
  renderEditForm(componentsByType) {
    const {
      activeThemePresetStyles,
      businessUnitId,
      fieldKey,
      formData = {},
      formSpec = {
        fields: []
      },
      hasThemePresetsAccess,
      scrollToThemeField,
      selectedBreakpoint,
      themeBreakpointStyles,
      themeInheritanceDataOverrides,
      trackInteraction,
      isUniversalThemeEditing,
      hasThemeEditAccess
    } = this.props;
    return /*#__PURE__*/_jsx(EditForm, {
      businessUnitId: businessUnitId,
      componentsByType: componentsByType || DefaultThemeMofoFields,
      breakpoint: selectedBreakpoint,
      breakpointStyles: themeBreakpointStyles,
      fieldKey: fieldKey,
      fieldDefaultOverrides: hasThemePresetsAccess && activeThemePresetStyles ? activeThemePresetStyles : undefined,
      FieldWrapper: ThemeSettingsFieldWrapper,
      flush: false,
      GroupLabelChild: this.renderFieldResetButton,
      hideBackLink: true,
      inheritanceDataOverrides: themeInheritanceDataOverrides,
      id: "theme-settings-form",
      LabelComponent: this.renderFieldLabel,
      lazyRenderGroups: true,
      module: formData,
      moduleSpec: formSpec,
      onFieldKeyChange: this.handleFieldKeyChange,
      onUpdate: this.handleFormUpdate,
      scrollToFieldOnMount: scrollToThemeField && scrollToThemeField.length > 0 ? scrollToThemeField.split('.') : undefined,
      trackFieldAction: trackInteraction,
      readOnly: Boolean(isUniversalThemeEditing && !hasThemeEditAccess)
    });
  }
  renderEditFormContainer() {
    const {
      formData = {},
      hasLoadedThemeSettings,
      hasLoadedUniversalThemeSettings,
      AsyncComponentContext
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), this.showPresets && this.renderPreset(), hasLoadedThemeSettings || hasLoadedUniversalThemeSettings ? /*#__PURE__*/_jsxs(SidebarSection, {
        onBoarding: "theme-settings-form",
        testId: "theme-settings-form",
        flush: true,
        paddingBlockStart: this.renderBreadcrumbs() || formData.group_foundation ? '500' : '0',
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: "THEME_SETTINGS_LOADED",
          children: AsyncComponentContext ? /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
            children: ({
              ThemeMofoFields
            }) => {
              if (!ThemeMofoFields) return null;
              return this.renderEditForm(ThemeMofoFields);
            }
          }) : this.renderEditForm()
        }), this.renderApplyButton()]
      }) : /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(ScrollingColumn, {
      "data-onboarding": "theme-settings",
      "data-test-id": "theme-settings",
      headerContent: !this.isPresetPanelOpen && this.renderHeaderContent(),
      scrollElementRef: this._columnRef,
      children: this.isPresetPanelOpen ? this.renderPresetListPanel() : this.renderEditFormContainer()
    });
  }
}
ThemeSettingsContainer.defaultProps = {
  trackInteraction: () => {}
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(ThemeSettingsContainer);